\import { autobind } from 'core-decorators'
import { History } from 'history'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import * as _ from 'lodash'
import { withRouter } from 'react-router-dom'
import { RequirementInstance } from '../../../../../models/Requirement'
import { Button, ButtonBar, NextButton } from '../../../../../shared/components/Button'
import { ContentContainerBody, SplitContentContainer } from '../../../../../shared/components/Content'
import { Headlines, InnerContainer } from '../../../../../shared/components/Elements'
import { Headline, SubHeadline } from '../../../../../shared/components/Headlines'
import { SideInformation } from '../../../../../shared/components/SideInformation'
import { Jaw } from '../../../../../shared/Constants'
import { CalculatorStoreInstance } from '../../../../../stores/CalculatorStore'
import { Routes } from '../../../../Routes'
import { Requirements } from '../../../Requirements'
import { SegmentedProgressBar } from '../../result/SegmentedProgressBar'

interface IProps {
  jaw: Jaw
  store?: CalculatorStoreInstance
  history?: History
}

@(withRouter as any)
@inject('store')
@observer
export class JawRequirementsView extends React.Component<IProps> {
  constructor (props: Readonly<IProps>) {
    super(props)

    const { jaw, store } = props
    if (!store.offer.hasJawRequirement(jaw)) {
      store!.offer.makeJawRequirement(jaw)
    }
  }

  // -------------------------------------------------------------------------- LIFECYCLE

  componentDidMount () {
    const { store, jaw } = this.props
    const { offer } = store
    if (jaw === 'lower' && !offer.upperJawRequirement) {
      store!.redirectToRoute(Routes.calculatorUpperJaw.subRoutes.requirements)
    }
  }

  // -------------------------------------------------------------------------- EVENTS

  @autobind
  private _onNextClick () {
    const { store, jaw } = this.props
    const { offer } = store

    if (jaw === 'lower' && !offer.upperJawRequirement.hasRequirements() && !offer.lowerJawRequirement.hasRequirements()) {
      alert('Bitte geben Sie mindestens in einem Kiefer fehlende Zähne an.')
      return
    }

    store!.goForward()
  }

  // -------------------------------------------------------------------------- RENDERING

  render () {
    const { jaw, store } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)

    return (<InnerContainer padded>
      <Headlines>
        <Headline centered>Welche Zähne fehlen Ihnen?</Headline>
        <SubHeadline centered>Sie können die einzelnen Zähne anklicken oder auswählen, dass Sie einen kompletten Zahnersatz benötigen.</SubHeadline>
      </Headlines>

      <SplitContentContainer>
        <ContentContainerBody padded>
          <Requirements jaw={jaw} />
        </ContentContainerBody>
        <SideInformation
          backButtonHidden={jaw === 'upper'}
          onBackClick={() => store!.goBack()}
          onNextClick={() => store!.goForward()}
          infoText={jaw === 'upper'
            ? 'jeder Zahnarzt in Deutschland ca. 20 Implantate im Jahr setzt, der durchschnittliche implacheck®-Implantologe hingegen 300?'
            : 'sogar die durchschnittliche Lebenserwartung von Patienten durch die verbesserte Kauleistung dank Implantaten ansteigt?'
          }
          longInfoText={jaw === 'upper'
            ? 'jeder Zahnarzt in Deutschland ca. 20 Implantate im Jahr setzt, der durchschnittliche implacheck®-Implantologe hingegen 300? Unsere implacheck®-Implantologen durchlaufen einen Auswahlprozess, der einen einheitlichen Qualitätsstandard des Netzwerks sicherstellt. Auf der Unterseite der einzelnen Implantologen haben Sie die Möglichkeit die einzelnen Fachqualifikationen unserer Behandler nachzuvollziehen. Neben tadellosem Kundenservice und einer außerordentlichen Patientenfreundlichkeit versichern wir unseren Patienten durch das Auswahlverfahren auch ein ganzheitliches Behandlungsspektrum und eine Praxisausstattung in den Partnerpraxen, die den neuesten Standards entspricht. '
            : 'sogar die durchschnittliche Lebenserwartung von Patienten durch die verbesserte Kauleistung dank Implantaten ansteigt? Dadurch, dass Implantatpatienten sich in Bezug auf die Nahrungsaufnahme nicht einschränken müssen und damit eine Verbesserung der allgemeinen Lebensqualität entsteht, steigt die Lebenserwartung erheblich. Auf unserer Website finden Sie weitere Informationen über die Vorteile von Implantatversorgungen.'
          }/>
      </SplitContentContainer>

      <ButtonBar>
        {jaw !== 'upper' ? <Button onClick={() => store!.goBack()}>Zurück</Button> : <div />}
        <SegmentedProgressBar segmentCount={2} segment={0} />
        <NextButton primary onClick={this._onNextClick}>{requirement.hasRequirements() ? 'Weiter' : 'Überspringen'}</NextButton>
      </ButtonBar>
    </InnerContainer>)
  }
}
